'use client';
import React from 'react';
import SwiperThumbs from '@/components/Gallery/SwiperThumbs';
import { EcwidProduct, Image } from '@/lib/ecwid/ecwidTypes';
import { ProductDescription } from './ProductDescription';
import { useVariantStore } from '../useVariantStore';
import { ProductDescriptionType } from '@/app/[locale]/admin/ecwid-products/[id]/SectionEditor';

const ProductHead: React.FC<{
    product: EcwidProduct;
    productDescription: ProductDescriptionType;
    locale: string;
    translation: Record<string, string>;
}> = ({ product, productDescription, locale, translation }) => {
    const [lastSelected, setLastSelected] = React.useState<Image | undefined>(
        undefined,
    );

    const { setProduct } = useVariantStore();
    setProduct(product);

    return (
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 xl:grid-cols-3">
            <div className="w-full lg:col-span-3 xl:col-span-2">
                <SwiperThumbs
                    buttonColor="#030712"
                    data={product?.galleryImages.map((image, i) => ({
                        id: i.toString(),
                        image: {
                            src:
                                i > 0
                                    ? image.url
                                    : lastSelected?.url || image.url,
                            width: image.width,
                            height: image.height,
                            altText: product.name,
                        },
                    }))}
                    imageSource="ecwid"
                    locale={locale}
                    onSlideChanged={activeIndex => {
                        setLastSelected(product.galleryImages[activeIndex]);
                    }}
                    sizes="(max-width: 1024px) 100vw, (max-width: 1536px) 66vw, 50vw"
                ></SwiperThumbs>
            </div>
            <div className="lg:col-span-2 xl:col-span-1">
                <ProductDescription
                    product={product}
                    productDescription={productDescription}
                    translation={translation}
                />
            </div>
        </div>
    );
};
export default ProductHead;
